import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {}

export const DebtsSection = ({ ...formProps }: Props) => {
  const { t } = useTranslation();

  return (
    <Section datax="debtsSection" title={t('client.client.debts.title')}>
      <FormContent {...formProps} />
    </Section>
  );
};
